import { render } from "./RanksChartCriteria.vue?vue&type=template&id=49c95544"
import script from "./RanksChartCriteria.vue?vue&type=script&lang=js"
export * from "./RanksChartCriteria.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__